import React, {lazy, useCallback, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
  changeContext,
  closeAppointmentModal,
  getAppointmentSlots,
  INIT_FILTER_STATE,
  isAssignSessionModalOpen,
  schedulerFacility,
  selectedDate,
  setContext,
  setFilters,
} from '../../../../store/reducers/appointments';
import AssignSessionModal from "../../../appointments/components/modals/assignSession";
import FilterSection from "../../../appointments/components/filterSection";
import { CONTEXT_OPTIONS } from "../../../appointments/utils/constants/appointmentSessionConstants";
import {Grid} from '@mui/material';
import HospitalSelection from '../../../appointments/components/hospitalSelection';
import PatientScheduledAppointmentsList from './scheduledAppointments/patientScheduledAppointmentsList';

const AppointmentsCalendarView = lazy(
  () => import("../../../appointments/components/calendarView/CalendarView"),
);

export default function PatientContextScheduler(props) {
  const dispatch = useDispatch();

  const filtersRef = useRef();

  const selectedDay = useSelector(selectedDate);
  const assignSessionModalOpen = useSelector(isAssignSessionModalOpen);
  const facility = useSelector(schedulerFacility);

  const closeModal = useCallback(
    (modal) => {
      dispatch(closeAppointmentModal(modal));
    },
    [dispatch, closeAppointmentModal],
  );

  useEffect(() => {
    dispatch(getAppointmentSlots());
  }, [selectedDay, facility, props.patient]);

  useEffect(() => {
    dispatch(setFilters(INIT_FILTER_STATE));
    dispatch(changeContext(CONTEXT_OPTIONS.CALENDAR));
    dispatch(getAppointmentSlots());

    return () => {
      dispatch(setContext(CONTEXT_OPTIONS.LIST));
      dispatch(setFilters(INIT_FILTER_STATE));
    };
  }, []);

  return (
    <Grid
      container
      pr={0.5} pt={0}
      alignContent="flex-start"
      style={{ maxHeight: "100%", height: "100%", position: 'relative' }}
    >
      <Grid container item xs={12} flexWrap='nowrap'>
        <Grid item container flexBasis='fit-content' maxWidth={250} pr={2} className='scroll-normal-white-y'>
          <PatientScheduledAppointmentsList patient={props.patient} />
        </Grid>

        <Grid item container flexGrow={1} alignContent='flex-start'>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            <HospitalSelection/>
          </div>

          <Grid item xs={12} ref={filtersRef} style={{position: 'sticky', top: -15, left: 0, right: 0}} sx={{pb: 1, pt: 1.5, bgcolor: 'background.default', zIndex: 10}}>
            <FilterSection patientContext />
          </Grid>

          <Grid item xs={12} style={{ height: filtersRef.current && `calc(100% - ${filtersRef.current.getBoundingClientRect().height}px)` }}>
            <AppointmentsCalendarView patientContext />
          </Grid>

          {assignSessionModalOpen && (
            <AssignSessionModal
              dischargeContext={false}
              onClose={closeModal}
              patientObj={props.patient}
              onCloseModal={props.closeModal}
              fromDischarge={props.fromDischarge}
              setSchedulerHour={props.setSchedulerHour}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
